import * as R from "ramda";
import InfiniteScroll from "react-infinite-scroller";
import { Affix, Avatar, Checkbox, Input, List } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  transformOssCoverUrl,
  transformResourceItemToFullPath,
  listAliyunResourcesApiWithMediaInfo,
} from "@/containers/Video/aliyun-service-api";
import { addVideoSnapShot } from "@/containers/Video/widgets/list-item";
import { getTypeName } from "@/containers/Video/widgets/upload-resource-modal";
import { formatSecondsToHumanReadable } from "@/containers/Video/widgets/asr-line";
import { sizeToHumanReadableSize } from "@/containers/Video/widgets/upload-resource-util";
import { uploadResourceChannelMap } from "@/containers/Video/tab-pages/video-resource-page";

const page_size = 20;

const composeThumbnailUrl = (item) => {
  //  [0].options.coverUrl
  const coverUrl = R.pathOr("", ["options", "coverUrl"], item);
  if (coverUrl) {
    return coverUrl;
  }
  const { path } = R.pipe(
    transformResourceItemToFullPath,
    transformOssCoverUrl,
    (item) => ({
      ...item,
      path: item.type === "video" ? addVideoSnapShot(item.path) : item.path,
    })
  )(item);
  return path;
};

export const SelectHeaderAndTail = ({
  orderId,
  value = null,
  onChange = R.T,
}) => {
  const ref = useRef(null);

  const [dataSource, setDataSource] = useState([]);
  const loadingRef = useRef(false);
  const hasMoreRef = useRef(true);
  const pageRef = useRef(1);

  const keywordRef = useRef("");
  const [keyword, setKeyword] = useState("");
  useEffect(() => {
    keywordRef.current = (keyword || "").trim();
  }, [keyword]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);
    const { items = [] } = await listAliyunResourcesApiWithMediaInfo({
      page: pageRef.current,
      page_size,
      orderId,
      status: 1,
      type: "video,image",
      name: keywordRef.current || "",
      channel: uploadResourceChannelMap.片头片尾,
    });
    setLoading(false);
    if (items.length < page_size) {
      hasMoreRef.current = false;
    }
    pageRef.current += 1;
    setDataSource(dataSource.concat(items));
    loadingRef.current = false;
  }, [dataSource]);

  return (
    <div
      ref={ref}
      style={{
        maxHeight: 300,
        overflow: "auto",
        width: "100%",
        padding: "0 12px",
        position: "relative",
      }}
    >
      <Affix offsetTop={0} target={() => ref.current}>
        <Input.Search
          placeholder="请输入关键字"
          value={keyword}
          onChange={(e) => {
            setKeyword(e.target.value);
          }}
          onSearch={() => {
            pageRef.current = 1;
            hasMoreRef.current = true;
            setDataSource([], () => {
              fetchData();
            });
          }}
        />
      </Affix>
      <InfiniteScroll
        initialLoad={true}
        pageStart={1}
        loadMore={fetchData}
        hasMore={hasMoreRef.current}
        useWindow={false}
      >
        <List
          loading={loading}
          dataSource={dataSource}
          renderItem={(item) => {
            const checked = R.equals(item.id, value?.id);
            const isVideo = R.equals(item.type, "video");
            const duration = R.pipe(
              R.pathOr("0", ["FileInfoList", 0, "FileBasicInfo", "Duration"]),
              Number
            )(item);
            return (
              <List.Item key={item.id}>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      size="large"
                      shape="square"
                      src={composeThumbnailUrl(item)}
                    />
                  }
                  title={<span style={{ fontSize: 8 }}>{item.name}</span>}
                  description={
                    <div className="flex" style={{ fontSize: 8 }}>
                      <span className="mr-2">{getTypeName(item.type)}</span>
                      <span className="mr-2">
                        {R.pathOr(
                          "",
                          ["FileInfoList", 0, "FileBasicInfo", "Width"],
                          item
                        ) +
                          "px * " +
                          R.pathOr(
                            "",
                            ["FileInfoList", 0, "FileBasicInfo", "Height"],
                            item
                          )}
                        px
                      </span>
                      <span className="mr-2">
                        {(() => {
                          const size = R.pipe(
                            R.pathOr("0", [
                              "FileInfoList",
                              0,
                              "FileBasicInfo",
                              "FileSize",
                            ]),
                            Number
                          )(item);
                          if (size) {
                            return sizeToHumanReadableSize(size);
                          }
                          return "--";
                        })()}
                      </span>
                      {isVideo && (
                        <span className="mr-2">
                          {formatSecondsToHumanReadable(duration)}
                        </span>
                      )}
                    </div>
                  }
                />
                <div>
                  <Checkbox
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      if (isChecked) {
                        // 当选中时，触发单选，仅保留当前 item
                        onChange(item);
                      } else {
                        // 当取消选中时，触发回调，设置为 null
                        onChange(null);
                      }
                    }}
                    checked={checked}
                  />
                </div>
              </List.Item>
            );
          }}
        ></List>
      </InfiniteScroll>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/select-header-and-tail.js